import { render, staticRenderFns } from "./request-contact.vue?vue&type=template&id=1f0863ba&"
import script from "./request-contact.vue?vue&type=script&lang=js&"
export * from "./request-contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/request-contact.vue
// module id = 1403
// module chunks = 0